import * as d3 from "d3";
export function getPaddedMax(data) {
  var maxValue = d3.max(data);
  var padding = maxValue / 20;
  return maxValue + padding;
}
export function getPaddedMin(data) {
  var minValue = d3.min(data);
  var padding = minValue / 20;
  minValue = minValue - padding;
  return minValue > 0 ? minValue : 0;
}
export function getPaddedMaxWithoutRestrictions(data) {
  var maxValue = d3.max(data, function (d) {
    return d;
  });
  var padding = maxValue / 20;
  return maxValue + padding;
}
export function getPaddedMinWithoutRestrictions(data) {
  var minValue = d3.min(data, function (d) {
    return d;
  });
  var padding = minValue / 20;
  var padded = padding < 0 ? minValue + padding : minValue - padding;
  return padded > 0 ? 0 : padded;
}
export var allGraphTypes = [{
  id: "timeline",
  label: "Tidslinje",
  icon: "lineGraph"
}, {
  id: "barchart",
  label: "Stapeldiagram",
  icon: "barChart"
}, {
  id: "deviation",
  label: "Avvikelsediagram",
  icon: "deviationChart"
}, {
  id: "heatchart",
  label: "Tabelldiagram",
  icon: "heatChart"
}, {
  id: "spider",
  label: "Spindeldiagram",
  icon: "spiderChart"
}, {
  id: "stackedarea",
  label: "Staplat ytdiagram",
  icon: "stackedBarchart"
}, {
  id: "area",
  label: "Ytdiagram",
  icon: "stackedLineGraph"
}, {
  id: "donut",
  label: "Ringdiagram",
  icon: "pieChart"
}, {
  id: "cake",
  label: "Cirkeldiagram",
  icon: "pieChart"
}, {
  id: "highlights",
  label: "Utdrag",
  icon: "browser"
}];